import {Control, Controller, UseFormReturn} from 'react-hook-form';
import {CheckOutlined, CloseOutlined} from '@ant-design/icons';
import {Button, DatePicker, Input, Select} from 'antd';
import dayjs from 'dayjs';
import {CarEquipmentDto, GarageSpotEquipmentStatus} from '../../../../../../PRMGApiClient';

const {TextArea} = Input;

export const GarageSpotEquipmentStatus2LabelMapping = {
  [GarageSpotEquipmentStatus.InStorage]: 'In storage',
  [GarageSpotEquipmentStatus.Issued]: 'Issued',
  [GarageSpotEquipmentStatus.RemovedFromStorage]: 'Removed from storage',
};

const mapGarageSpotStatusToOptions = (
  Object.keys(GarageSpotEquipmentStatus) as Array<keyof typeof GarageSpotEquipmentStatus>
).map((key) => {
  return {
    value: GarageSpotEquipmentStatus[key],
    label: GarageSpotEquipmentStatus2LabelMapping[key],
  };
});

interface EquipmentEditRowProps {
  form: UseFormReturn<CarEquipmentDto>;
  control?: Control<CarEquipmentDto>;
  onConfirm: () => void;
  onCancel?: () => void;
}

export const EquipmentEditRow: React.FunctionComponent<EquipmentEditRowProps> = (props): JSX.Element => {
  const {
    form: {
      control,
      formState: {errors},
    },
    onConfirm,
    onCancel,
  } = props;

  return (
    <tr>
      <td>
        <Controller
          name="name"
          control={control}
          rules={{required: true}}
          render={({field: {onChange, value}}) => (
            <TextArea
              status={errors.name && 'error'}
              value={value ?? ''}
              onChange={(e) => onChange(e.target.value)}
              autoSize
            />
          )}
        />
      </td>
      <td>
        <Controller
          name="quantity"
          control={control}
          rules={{required: true}}
          render={({field: {onChange, value}}) => (
            <Input
              status={errors.quantity && 'error'}
              type="number"
              value={value ?? ''}
              onChange={(e) => onChange(e.target.value)}
            />
          )}
        />
      </td>
      <td>
        <Controller
          name="status"
          control={control}
          rules={{required: true}}
          render={({field: {onChange, value}}) => (
            <Select
              status={errors.status && 'error'}
              style={{width: 190}}
              defaultValue={mapGarageSpotStatusToOptions[0].value}
              value={mapGarageSpotStatusToOptions.find((item) => item.value === value) ?? ''}
              onChange={(option) => onChange(option)}
              options={mapGarageSpotStatusToOptions}
            />
          )}
        />
      </td>
      <td>
        <Controller
          name="description"
          control={control}
          render={({field: {onChange, value}}) => (
            <TextArea value={value ?? ''} onChange={(e) => onChange(e.target.value)} autoSize />
          )}
        />
      </td>
      <td>
        <Controller
          name="location"
          rules={{required: true}}
          control={control}
          render={({field: {onChange, value}}) => (
            <TextArea
              status={errors.location && 'error'}
              value={value ?? ''}
              onChange={(e) => onChange(e.target.value)}
              autoSize
            />
          )}
        />
      </td>
      <td>
        <Controller
          name="addedDate"
          rules={{required: true}}
          control={control}
          render={({field: {onChange, value}}) => (
            <DatePicker onChange={(value) => onChange(value?.toDate())} value={dayjs(value) ?? new Date()} />
          )}
        />
      </td>
      <td>
        <div className="flex pr-0 items-center">
          <Button type="link" icon={<CheckOutlined />} onClick={onConfirm} />
          <Button type="link" icon={<CloseOutlined />} onClick={onCancel} />
        </div>
      </td>
    </tr>
  );
};
